"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationList = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTransitionGroup = require("react-transition-group");

var _notificationList = require("./notification-list.styled");

var _notification = require("./notification");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationList = function NotificationList(props) {
  var items = props.items,
      measure = props.measure,
      timeout = props.timeout;
  return /*#__PURE__*/_react.default.createElement(_notificationList.NotificationListStyled, {
    items: items,
    measure: measure,
    timeout: timeout
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, items === null || items === void 0 ? void 0 : items.map(function (props, index) {
    return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
      key: "notification-".concat(index),
      timeout: timeout,
      classNames: "animation"
    }, /*#__PURE__*/_react.default.createElement(_notification.Notification, props));
  })));
};

exports.NotificationList = NotificationList;
NotificationList.defaultProps = {
  measure: 'md',
  timeout: {
    enter: 150,
    exit: 100
  }
};
NotificationList.displayName = 'NotificationList';